module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp1_5012.3c2015e5.png";